import { BaseError } from '@goodt-wcore/errors';

/**
 * @deprecated
 * @class ApiClientCancelError
 */
class ApiClientRequestCancel extends BaseError {}

export { ApiClientRequestCancel };
